<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="uDfmT6cUq6XjobpY83shUlC">
<p class="Normal ParaOverride-7"><span class="CharOverride-7">I</span><span class="CharOverride-8">straighten my back, feeling the ligaments of my spine snap in long-awaited relief. My thumb swipes the cracked surface of the phone screen. The autumn wind relieves my sweat. Let’s hope that eyeliner isn’t trickling down my cheek. Sherbourne station is suffocatingly hot compared to the chill of oncoming rain outside.</span></p>
<p class="Normal ParaOverride-9"><span class="CharOverride-9">&lt; Close now. &gt;</span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">My message is an apology. </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">I’m running late. Devising a story about the ills of public transit to avoid admitting that mere hours ago, I was formulating excuses not to come at all. </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">The phone vibrates as I’m halfway to slipping it back in my pocket. More of a whimper than a healthy buzz.</span></p>
<p class="Normal ParaOverride-10"><span class="CharOverride-9">&lt; See you soon :) &gt;</span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">That was quick. I didn’t expect a response. </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">Shouldn’t Matt be preoccupied with his roleplay session? </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">Either he’s a very distractible DM, or they’re dawdling between half-baked character sheets and a table covered in convenience store snack food.</span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">I entertain the idea that they might be postponing on my account. But didn’t I tell him that I’d be a silent observer? </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">God, I hope they’re not waiting up. </span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">The thought carries a bitter aftertaste of guilt. The image of a door opening to five expectant pairs of eyes, scrutinizing their overdue guest.</span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">As if I need another reason to manufacture my escape.</span></p>
<p class="Normal ParaOverride-7"><span class="CharOverride-8">I clatter my way down the street, avoiding cigarette butts and construction pylons. Mountains of forbidding concrete loom to either side. My hands catch droplets. Still shy of a storm. My heels catch familiar cracks in the sidewalk.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stsebastianepub_split4.vue?b0286326